var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"WorldPanelDiv"}},[_c('h2',{staticClass:"pl-2 pt-3 pb-0"},[_vm._v("Worldtrix Entities")]),_c('TribeList'),_c('TaskForcesList'),_c('ObjectsList'),_c('TerrainList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }